var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaptop = function SvgLaptop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.042 8.167.998 10.254c-.08.162-.123.34-.123.521v.307c0 .642.517 1.163 1.159 1.167l.124.001H11.962a1.167 1.167 0 0 0 1.163-1.167v-.308c0-.18-.042-.36-.123-.521l-1.044-2.087v-5.25c0-.645-.522-1.167-1.166-1.167H3.208c-.644 0-1.166.522-1.166 1.167z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.822 8.604h10.354M4.666 12.25l.45-1.351a.583.583 0 0 1 .554-.399h2.659c.251 0 .474.16.553.399l.45 1.351"
  })));
};
export { SvgLaptop as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMWY3ZjZjYjc5MjdkYzgzMWEyZDM0OGE3YWY5YjE0ZWIuc3ZnIjs=";